import React, { ReactNode } from 'react'
import {
    Container,
    Subtitle,
    InfoContainer,
    InfoItem,
    PriceContainer,
    PriceVat,
    Price
} from './TransactionOverview.style'
import { Title } from '@components/Title/Title.component'

interface TransactionOverviewProps {
    children: ReactNode
    title: string
    onBackClick?: () => void
}

const TransactionOverview = ({ children, title, onBackClick }: TransactionOverviewProps) => {
    return (
        <Container>
            <Title text={title} onBackClick={onBackClick} />
            {children}
        </Container>
    )
}

const TransactionSubtitle = ({ children }: { children: ReactNode }) => {
    return <Subtitle>{children}</Subtitle>
}

const TransactionInfoContainer = ({
    children,
    className,
    divider = false
}: {
    children: ReactNode
    className?: string
    divider?: boolean
}) => {
    return (
        <InfoContainer className={className} $divider={divider}>
            {children}
        </InfoContainer>
    )
}

const TransactionInfoItem = ({ children, className }: { children: ReactNode; className?: string }) => {
    return <InfoItem className={className}>{children}</InfoItem>
}

const TransactionPriceContainer = ({ children }: { children: ReactNode }) => {
    return <PriceContainer>{children}</PriceContainer>
}

const TransactionPrice = ({ children }: { children: ReactNode }) => {
    return <Price>{children}</Price>
}

const TransactionPriceVat = ({ children }: { children: ReactNode }) => {
    return <PriceVat>{children}</PriceVat>
}

TransactionOverview.Subtitle = TransactionSubtitle
TransactionOverview.InfoContainer = TransactionInfoContainer
TransactionOverview.InfoItem = TransactionInfoItem
TransactionOverview.PriceContainer = TransactionPriceContainer
TransactionOverview.Price = TransactionPrice
TransactionOverview.PriceVat = TransactionPriceVat

export default TransactionOverview
